import React, { useEffect, useState } from 'react';
import { adminBusinessAPI } from '../api';
import { fmtDate } from '../utils/date';

export default function Businesses() {
  const [businesses, setBusinesses] = useState([]);
  const [loading,    setLoading]    = useState(true);

  useEffect(() => { adminBusinessAPI.list().then(r => setBusinesses(r.data.businesses || [])).catch(() => {}).finally(() => setLoading(false)); }, []);

  if (loading) return <p>Loading…</p>;

  return (
    <div>
      <h1>Businesses ({businesses.length})</h1>
      <table>
        <thead><tr><th>Name</th><th>Currency</th><th>Owner</th><th>Members</th><th>Sales</th><th>Since</th></tr></thead>
        <tbody>
          {businesses.map(b => (
            <tr key={b.id}>
              <td><strong>{b.name}</strong></td>
              <td>{b.currency}</td>
              <td>{b.owner_name}<br /><span style={{ color: '#64748b', fontSize: '0.8rem' }}>{b.owner_email}</span></td>
              <td>{b.member_count}</td>
              <td>{b.sale_count}</td>
              <td>{fmtDate(b.created_at)}</td>
            </tr>
          ))}
          {!businesses.length && <tr><td colSpan={6} style={{ color: '#64748b' }}>No businesses yet.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
